"use client";

import { c as _c } from "react/compiler-runtime";
import { LockClosedIcon } from "@heroicons/react/24/outline";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
export default function DropForgeNoPower() {
  const $ = _c(8);
  const router = useRouter();
  const [seconds, setSeconds] = useState(10);
  let t0;
  let t1;
  if ($[0] !== router || $[1] !== seconds) {
    t0 = () => {
      if (seconds === 1) {
        const t = setTimeout(() => router.replace("/"), 1000);
        return () => clearTimeout(t);
      }
      if (seconds > 1) {
        const t_0 = setTimeout(() => setSeconds(_temp), 1000);
        return () => clearTimeout(t_0);
      }
    };
    t1 = [seconds, router];
    $[0] = router;
    $[1] = seconds;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LockClosedIcon className="tw-h-[100px] tw-w-[100px] tw-flex-shrink-0 tw-text-iron-500" />;
    t3 = <b className="tw-text-lg tw-text-iron-200">You have no power here</b>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== seconds) {
    t4 = <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-py-12 tw-text-center">{t2}{t3}<p className="tw-text-base tw-text-iron-500">Redirecting in {seconds}</p></div>;
    $[6] = seconds;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp(s) {
  return s - 1;
}